

export const ensureUniqueItems = (newItems, existingItems) => {
  return newItems.filter(
    (newItem) => !existingItems.some((item) => item.id === newItem.id)
  );
};


const _handleLock = (portfolioItems, setPortfolioItems, isLocked) => {
    const updatedItems = portfolioItems.map((item) => ({ ...item, _locked: isLocked }));
    setPortfolioItems(updatedItems);
};

export const handleLockAll = (portfolioItems, setPortfolioItems) => {
    _handleLock(portfolioItems, setPortfolioItems, true);
};

export const handleUnlockAll = (portfolioItems, setPortfolioItems) => {
    _handleLock(portfolioItems, setPortfolioItems, false);
};


const scaleWeights = (items, scalePercentage) => {
    // Determine the scaling factor from the percentage
    const scaleFactor = 1 + scalePercentage / 100;
    // Scale and update weights for unlocked items proportionally.
    const scaledItems = items.map((item) => {
        if (!item._locked) {
            // Apply the scaling factor to each unlocked item's weight.
            const newWeight = item.wgt * scaleFactor;
            return { ...item, wgt: newWeight };
        }
        return item;
    });
    return scaledItems
};

/**
 * Handles scaling portfolio of items up or down by a scalar value
 * The same scaleWeights function can be used for both up and down scaling.
 * @param portfolioItems {Array[object]}
 * @param setPortfolioItems {function} - The state update function
 * @param scalePercentage {number} - The percentage to scale by
 */
export const handleScaleUp = (portfolioItems, setPortfolioItems, scalePercentage) => {
    const scaledItems = scaleWeights(portfolioItems, scalePercentage);
    setPortfolioItems(scaledItems);
};

export const handleScaleDown = (portfolioItems, setPortfolioItems, scalePercentage) => {
    // Scaling down is handled by simply passing a negative percentage
    const scaledItems = scaleWeights(portfolioItems, -scalePercentage);
    setPortfolioItems(scaledItems);
};

/**
 * Handles scaling portfolio of items to fill 100% of the portfolio equally
 * @param portfolioItems {Array[object]}
 * @param setPortfolioItems {function} - The state update function
 */
export const handleEqualFill = (portfolioItems, setPortfolioItems) => {
    const unlockedItems = portfolioItems.filter((item) => !item._locked);
    const lockedItems = portfolioItems.filter((item) => item._locked);
    const remainingWeight = 100 - lockedItems.reduce((sum, item) => sum + item.wgt, 0);
    const equalWeight = remainingWeight / unlockedItems.length;
    const updatedItems = portfolioItems.map((item) =>
      item._locked ? item : { ...item, wgt: equalWeight }
    );
    setPortfolioItems(updatedItems);
};

/**
 * Handles scaling portfolio of items to fill 100% of the portfolio pro rata based on existing weight proportions
 * @param portfolioItems {Array[object]}
 * @param setPortfolioItems {function} - The state update function
 */
export const handleProRataFill = (portfolioItems, setPortfolioItems) => {
    const unlockedItems = portfolioItems.filter((item) => !item._locked);
    const totalWeight = unlockedItems.reduce((sum, item) => sum + item.wgt, 0);

    if (totalWeight === 0) {
      // If all weights are zero, fallback to equal fill
      handleEqualFill();
    } else {
      const scaleFactor = 100 / totalWeight;
      const updatedItems = portfolioItems.map((item) =>
        item._locked ? item : { ...item, wgt: item.wgt * scaleFactor }
      );
      setPortfolioItems(updatedItems);
    }
};

/**
 * Utility function called to reformat the weights to be within 0,1 range and drop any private keys added in builder
 *
 * @param items {Array[object]}
 * @returns {*[]}
 */
export const reformatWeightMultiple = (items)=>{
    let newItems = [];
    items.forEach((item)=>{
        let newItem = {};
        for (let key in item){
            // if (!key.startsWith('_')){
            newItem[key] = item[key];
            // }
        }
        newItem.wgt *= 0.01;
        newItems.push(newItem);
    });
    return newItems;
}